@import '../../constants/spacing.module.less';

.container {
  margin-top: @space-8;
  align-items: center;
  gap: @space-8;
  padding: @space-12;
  font-size: 14px;

  border: 1px solid var(--error--message--border-color--4);
  background: var(--error--message--background-color--1);

  .button {
    display: flex;
    padding: @space-8 @space-12;
    align-items: center;
    gap: @space-8;
    max-width: 140px;

    svg {
      width: @space-12;
    }
  }
}
